import React from 'react';
import ReactDOM from 'react-dom';
const $ = window.$;

$.fn.tab = function (options) {
  $(window).off('.daniTabs');
  $(this).off('.daniTabs');

  var items = this;
  $(this).each(function (k) {
    var that = items[k];
    const moveBar = function (tab_bar, tab_title) {
      if($(tab_title).position()) {
        $(tab_bar).css({ width: $(tab_title).width() + 'px', left: $(tab_title).position().left });
      }
    };
    const moveContent = function (tab_content) {
      try {
        $(tab_content).parent().css({ left: -$(tab_content).position().left });
      } catch(e) {
        console.error(e)
      }
    };
    moveBar($(that).find('.tab_bar'), $(that).find('.tab_title_active'));
    if ($(that).hasClass('tab_hover')) {
      $(that).find('.tab_title').on("mouseover", function () {
        moveBar($(this).parent().find('.tab_bar'), $(this));
      });
      $(that).on("mouseout.daniTabs", function () {
        moveBar($(this).find('.tab_bar'), $($(this).find('.tab_title_active')));
      });
    }
    $(that).find('.tab_title').on("click.daniTabs", function (event) {
      moveBar($(this).parent().find('.tab_bar'), $(this));
      $(this).parent().find('.tab_title').removeClass('tab_title_active');
      $(this).addClass('tab_title_active');
      var tab_content = $($(this).find('a').attr('href'));
      moveContent(tab_content);
      // TODO: Investigate why the event propagation was stopped by returning false...
      //return false;
      event.preventDefault(); // Avoid changing window location change by clicking tab handles' anchors
    });
    $(window).on('resize.daniTabs', function () {
      moveBar($(that).find('.tab_bar'), $(that).find('.tab_title_active'));
      var tab_content = $($(that).find('.tab_title_active').find('a').attr('href'));
      moveContent(tab_content);
    });
    $(window).on("orientationchange.daniTabs", function () {
      moveBar($(that).find('.tab_bar'), $(that).find('.tab_title_active'));
      var tab_content = $($(that).find('.tab_title_active').find('a').attr('href'));
      moveContent(tab_content);
    });
  });
};

export const Tabs = React.createClass({ 
  getInitialState() {
    return {
      mounted: true,
    }
  },
  componentWillMount() {
    this.tabsCount = 0;
  },
  componentDidMount() {
    $(this.tabUl).tab();
  },
  ulRef(element) {
    this.tabUl = ReactDOM.findDOMNode(element);
  },
  liRef(element) {
    if(element) {
      this.tabsCount++;
    } else {
      this.tabsCount--;
    }
  },
  componentWillReceiveProps() {
    this.lastTabsCount = this.tabsCount
  },
  componentDidUpdate() {
    if(this.lastTabsCount !== this.tabsCount) {
      this.reinitTabs();
    }
  },
  reinitTabs() {
    if(!this.reiniting) {
      this.reiniting = true;
      this.setState({mounted: false});
      setTimeout(() => {
        this.setState({mounted: true});
        $(this.tabUl).tab();
        this.reiniting = false;
      });
    }
  },
  render() {
    return (
      this.state.mounted && this.props.children({ulRef: this.ulRef, liRef: this.liRef})
    )
  }
});

export default {Component: Tabs};



// WEBPACK FOOTER //
// ./src/visual/component/Tabs.js